import { CollectionEntity } from "@busy-human/gearbox";
import { Builders } from "../Builders/index.js";
export var Transactions;
(function (Transactions) {
    function mapBuilderTypeToTransactionIdField(builderType) {
        const fieldMap = {
            [Builders.BuilderType.Builder]: "teenBuilderId",
            [Builders.BuilderType.ParentBuilder]: "parentBuilderId",
            [Builders.BuilderType.TripLeader]: "tripLeaderId",
            [Builders.BuilderType.AtHomeParent]: "teenBuilderId", // Change me!
            [Builders.BuilderType.LocalCoordinator]: "teenBuilderId" // Change me!
        };
        return fieldMap[builderType];
    }
    Transactions.mapBuilderTypeToTransactionIdField = mapBuilderTypeToTransactionIdField;
    function Default() {
        return {
            type: 'payment',
            invoiceId: '',
            amount: 0,
            createdTimestamp: new Date().toISOString(),
            updatedTimestamp: new Date().toISOString(),
            simpleState: "pending",
            name: ""
        };
    }
    Transactions.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    Transactions.CollectionClass = CollectionClass;
    Transactions.Collection = new CollectionClass({ path: "Transactions" });
    async function getZohoId(firebaseId) {
        const item = await Transactions.Collection.fetchData(firebaseId);
        if (item) {
            return item.zohoId;
        }
        else {
            return undefined;
        }
    }
    Transactions.getZohoId = getZohoId;
})(Transactions || (Transactions = {}));
//# sourceMappingURL=index.js.map